/* Project Import will be here */
import { post, IRequest } from "./index";
import { ILanguageRequestParam } from "models/profileModels";
/* Project Import will be here */

export const getCategoryMenu = () => {
  const request: IRequest = {subUrl: `/Product/DynamicFilter`};
  return post(request);
};

export const getDMSUserIdentity = () => {
  const request: IRequest = {subUrl: `/Appconfig/GetPublicKey`};
  return post(request);
}

export const updateUserLanguageApi = (data: ILanguageRequestParam) => {
  const request: IRequest = { subUrl: `/common/UpdateUserLanguage`, data };
  return post(request);
};

export const updateFcmTokenApi = (fcmToken) => {
  const request: IRequest = {subUrl: `/AppConfig/UpdateFCM`};

  /* Assign FCM token in the request header */
  if (fcmToken !== null)
    request.headers = { 'fcm-token': fcmToken }

  return post(request);
};